import { AuthModelExtension, BaseAuthModel } from '@libs/shared';
import { TIMEZONE_KEY } from '@fx-ui/fine-design';
import { GlobalOptions, initGlobalAuth } from '../utils';
import { globalState } from './globalState';

/**
 * 该文件内容会导出给子产品使用，不要随意添加内容
 */
export class AuthModel<T extends AuthModelExtension = {}> extends BaseAuthModel<T, TIMEZONE_KEY> {
    /**
     * 当前企业外部用户功能是否可用（灰度控制）
     * TODO @liaw 后面会删掉
     */
    get isExternalUserAvailable() {
        const suiteId = globalState.suiteId;
        if (suiteId !== undefined) {
            // 子产品需额外检查是否有外部用户功能
            const isCurrentSuiteHasExternal =
                this.getSuiteModuleById(suiteId)?.has_external ?? false;
            if (!isCurrentSuiteHasExternal) {
                return false;
            }
        }
        if (globalState.externalUserBeta) {
            return this.isTenantModuleEnabled('external');
        }
        /**
         * 不走灰度控制时，默认该功能可用
         * @see https://code.fineres.com/projects/FX/repos/fx-corp-web/pull-requests/2079/overview?commentId=2896116
         */
        return true;
    }

    init(options?: GlobalOptions) {
        return initGlobalAuth(options).then((res) => {
            this.initConfig(res);
        });
    }
}

export const authModel = new AuthModel();
